/**
 * WordPress dependencies
 */
import { addFilter } from '@wordpress/hooks';

const ProNoticeBlock = () => {
	const { is_pro_activated: isProActive } = window._gutenify_vars;
	if ( !! isProActive ) {
		return '';
	}
	return <div className="gutenify--pro-notice--inline"><i className="fa fa-envelope-open"></i> Want to enjoy all feature of blocks? Checkout <a href="https://gutenify.com/pricing/" target="__blank">Gutenify PRO</a>.</div>;
};

const hookPrefixes = [ 'button', 'buttons', 'container', 'content-toggle-item', 'faqs', 'gallery-carousel', 'grid', 'grid-item', 'icon', 'info-box', 'map', 'post-carousel', 'gutenify-post-list', 'section-title', 'service', 'gutenify-slider-item', 'slider', 'star-rating', 'team', 'team-member', 'testimonials', 'wc-product-carousel', 'wc-product-list' ];

hookPrefixes.forEach( ( hookPrefix ) => {
	addFilter(
		`gutenify-block-${ hookPrefix }-inspector-controls`,
		`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls1`,
		( content, props ) => {
			return [
				...content,
				<ProNoticeBlock
					key={ `gutenify-block-${ hookPrefix }-inspector-controls-basic-control1s` }
				/> ];
		} );
} );
